import { isNil } from "lodash";
import { useGrowl } from "PFApp/use_growl";
import { Button } from "PFComponents/button";
import { ActivitiesCollection } from "PFCore/hooks/queries/activities/query_keys";
import { useActivitiesInvalidate } from "PFCore/hooks/queries/activities/use_activities_invalidate";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { useSavedCreate, useSavedDelete } from "PFCore/hooks/queries/saved";
import { MatchedActivity } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

export const SaveButton = ({ role }: { role: MatchedActivity["activity"] }) => {
  const { data: currentProfile } = useCurrentProfile();

  const growl = useGrowl();
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.roleDetails" });
  const { t: commonT } = useTranslation();
  const { invalidateByCollection } = useActivitiesInvalidate();

  const isSaved = !isNil(role.saved_id);

  const { mutateAsync: saveRole } = useSavedCreate();
  const { mutateAsync: deleteSaved } = useSavedDelete();

  const handleShareClick = async () => {
    try {
      if (isSaved) {
        await deleteSaved({ id: role.id });
      } else {
        await saveRole({ profileId: currentProfile.id, activityId: role.id });
      }
      invalidateByCollection(ActivitiesCollection.Saved);
      invalidateByCollection(ActivitiesCollection.MarketplaceActivity, role.id);
      growl({
        message: isSaved ? t("removeOpportunity.success") : t("saveOpportunity.success"),
        kind: "success"
      });
    } catch {
      growl({
        message: commonT("thereWasAnError"),
        kind: "error"
      });
    }
  };

  return <Button kind={isSaved ? "tertiary" : "secondary"} icon="save" onClick={handleShareClick} />;
};
